import { createContext, useState } from "react";

const TOKEN = "ACCESS_TOKEN";
const PHONE = "PHONE_NUMBER";

const AuthContext = createContext({
  token: null,
  phoneNumber: null,
  savePhoneNumber: (phoneNumber) => {},
  saveToken: (flag) => {},
  logout: () => {},
});

export const AuthProvider = ({ children }) => {
  const regData = localStorage.getItem(TOKEN);
  let initReg = null;
  if (regData) {
    initReg = regData;
  }

  const phoneData = localStorage.getItem(PHONE);
  let initPhone = null;
  if (phoneData) {
    initPhone = phoneData;
  }

  const [token, setToken] = useState(initReg);
  const [phoneNumber, setPhone] = useState(initPhone);

  const accessHandler = (accessToken) => {
    setToken(accessToken);
    localStorage.setItem(TOKEN, accessToken);
  };

  const savePhoneHandler = (phoneNumber) => {
    setPhone(phoneNumber);
    localStorage.setItem(PHONE, phoneNumber);
  };

  const logoutHandler = () => {
    setToken(null);
    setPhone(null);
    localStorage.removeItem(TOKEN);
    localStorage.removeItem(PHONE);
  };

  const value = {
    token,
    phoneNumber,
    savePhoneNumber: savePhoneHandler,
    saveToken: accessHandler,
    logout: logoutHandler,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export default AuthContext;
